export const removeTrailingZeros = (price: string) => {
  return price.replace(/(\.[0-9]*[1-9])0+$|\.0*$/, "$1");
};
